import React, {useEffect} from 'react';
import {toRelativeUrl} from '@okta/okta-auth-js';
import {Outlet} from 'react-router-dom';
import {LoaderSplash} from '../../components/atoms/LoaderSplash';
import {useOkta} from '../../hooks';
import {AnonymousRoutes} from '../routes';
import {useNavigation} from '../useNavigation';

const Authenticated = () => {
  const {oktaAuth, authState} = useOkta();

  const {goToPath} = useNavigation();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin,
      );
      oktaAuth.setOriginalUri(originalUri);
      goToPath(AnonymousRoutes.LOGIN, {replace: true});
    }
  }, [oktaAuth, authState, goToPath]);

  if (!authState || !authState.isAuthenticated) {
    return <LoaderSplash />;
  }

  return <Outlet />;
};

export default React.memo(Authenticated);
